module.exports = __webpack_public_path__ + "static/img/icon9.4ead331a.png";